import { render, staticRenderFns } from "./RegisterSongTable.vue?vue&type=template&id=01d9ee06&scoped=true"
import script from "./RegisterSongTable.vue?vue&type=script&lang=ts"
export * from "./RegisterSongTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d9ee06",
  null
  
)

export default component.exports